<template>
  <div class="wrapper" id="attendees-page">
    <parallax
      class="section page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <page-header />
    </parallax>

    <div class="main main-raised" ref="page">
      <div class="section">
        <div class="md-layout-item md-size-65 md-small-size-85 mx-auto md-alignment-top-center">
          <h2
            class="black text-center text-primary"
            style="margin:0px 0px 30px 0px"
          >{{$t('List of participants')}}</h2>
          <h4
            class="text-center regular"
            v-if="!attendeesSettings.show"
          >{{attendeesSettings.noAttendeesText[language.code]}}</h4>
          <attendees-list v-else />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {} from "@/components";
import axios from "@/util/axios";
import Mixins from "@/plugins/basicMixins";
import AttendeesList from "./components/Attendees//AttendeesList";
import PageHeader from "./layout/PageHeader";

export default {
  mixins: [Mixins.HeaderImage],
  components: {
    AttendeesList,
    PageHeader
  },
  bodyClass: "landing-page",
  computed: {
    ...mapGetters({
      conference: "conference/current",
      language: "language/current",
      attendeesSettings: "user/attendeesSettings"
    })
  },
  data() {
    return {
      image: require("@/assets/img/conference/landing-bg.jpg")
    };
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}

h1.info-title {
  font-size: 5rem;
}
.info-title {
  color: white !important;
}

.info-title > hr {
  color: white;
}

.page-header .container {
  max-width: 70% !important;
}

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  font-size: 0.85rem;
}
</style>

<style lang="scss">
#attendees-page {
  .md-field.md-form-group::after,
  .md-field.md-form-group::before,
  .md-field.md-datepicker::after,
  .md-field.md-datepicker::before {
    width: 100%;
  }
  .md-field.md-form-group + .md-error {
    margin-left: 0px;
  }
}
</style>